import React from "react";

import CardRegisterEnterprise from "components/Cards/CardRegisterEnterprise";

export default function RegisterUser() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <CardRegisterEnterprise/>
        </div>
      </div>
    </>
  );
}
